import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const BackgroundAnimation = keyframes`
  0% { background-position: 0 0; }
  50% { background-position: 100% 100%; }
  100% { background-position: 0 0; }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;
  background: linear-gradient(135deg, #0F4C81, #1A6FBF, #ffa500);
  background-size: 400% 400%;
  animation: ${BackgroundAnimation} 10s infinite alternate;
  color: #fff;
`;

const Message = styled.h1`
  font-size: 3rem;
  margin: 20px 0;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Countdown = styled.div`
  font-size: 1.5rem;
  margin: 20px 0;
`;

const UnderConstruction = () => {
  const calculateTimeLeft = () => {
    const targetDate = new Date("2024-01-01T00:00:00"); // Adjust the target date as needed
    const now = new Date();
    const difference = targetDate - now;
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const timerComponents = Object.keys(timeLeft).map((interval) => {
    if (!timeLeft[interval]) {
      return null;
    }
    return (
      <span key={interval}>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  return (
    <Container>
      <Message>Our Website is Under Construction</Message>
      <Countdown>
        {timerComponents.length ? timerComponents : <span>Launching Soon!</span>}
      </Countdown>
      <p>Stay tuned! We’ll be launching our website shortly.</p>
    </Container>
  );
};

export default UnderConstruction;
